import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";

let Notification = () => {
  let [data, setData] = useState();

  let [pikk, setPikk] = useState("XOPAY");

  let [pikks, setPikks] = useState("");

  let [show, setShow] = useState(false);

  let navigate = useNavigate();


  const [isFourToFivePM, setIsFourToFivePM] = useState(false);

  // Function to check the current time
  const checkTime = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    if (hours === 16 && minutes >= 0 && minutes < 60) {
      setIsFourToFivePM(true);
    } else {
      setIsFourToFivePM(false);
    }
  };

  useEffect(() => {
    // Check time immediately
    checkTime();

    // Set an interval to check the time every minute
    const interval = setInterval(checkTime, 60000); // 60000 ms = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, []);



  useEffect(() => {
    Start();
    newstart() 
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let newstart = async () => {
    let apicall = await axios({
        method: "get",
        url: Base_url + "/common/getnotificationsus", 
      })
       .then((dat) => { 

          console.log(dat.data.data, "Jsson");
          if (dat.data.status === true) { 
            setData(dat.data.data)
          } else { 

          }
        })
        .catch((ee) => {
          console.log(ee)  
        });
  };

  let User = async () => {

    if( pikk === '' || pikks === ''){
      alert('Please enter all the fields')
      return
    }
    setShow(true)
    try {

      let pp = {  head : pikk, msg : pikks}; 

      let apicall = await axios({
        method: "post",
        url: Base_url + "/common/sendnoti",
        data: pp ,
      })
        .then((dat) => { 

          console.log(dat.data, "Jsson");
          if (dat.data.status === true) {
            setShow(false) 
          } else {   
          }
        })
        .catch((ee) => {
          console.log(ee)  
        });
    } catch (err) {
      console.log(err)  
    }
  };

  let Save = async () => {
    try {
      if( pikk === '' || pikks === ''){
        alert('Please enter all the fields')
        return
      }

      let pp = {  head : pikk, msg : pikks}; 

      let apicall = await axios({
        method: "post",
        url: Base_url + "/common/notificationsus",
        data: pp ,
      })
       .then((dat) => { 

          console.log(dat.data, "Jsson");
          if (dat.data.status === true) { 
            alert("Success");
            newstart()
          } else {  
            alert(" Failed");
          }
        })
        .catch((ee) => {
          console.log(ee) 
          alert(" Failed sdfvd");
        });


      
    } catch (err) {
      console.log(err) 
    }
  };


 let Usersubmit = async (head, msg) => {
    // Show confirm dialog with OK and Cancel buttons
    const result = window.confirm("Click Ok to send Notification");
    
    // Only run next function if user clicked OK (true)
    if (result) {
        await newsubmit(head, msg);
    } else {
        console.log("User cancelled the operation");
        // Handle cancel action here if needed
    }
  };

  let newsubmit = async (head, msg) => {
      // Your next function logic goes here
      console.log("Running newsubmit with:", head, msg);

      let pp = {  head : head , msg : msg}; 

      let apicall = await axios({
        method: "post",
        url: Base_url + "/common/notificationsus",
        data: pp ,
      })
       .then((dat) => { 

          console.log(dat.data, "Jsson");
          if (dat.data.status === true) { 
            alert("Success");
          } else {  
            alert(" Failed");
          }
        })
        .catch((ee) => {
          console.log(ee) 
          alert(" Failed sdfvd");
        });


      
      // Add your actual implementation here
  };


  let UserDelete = async (dat) => {
    console.log("Running newsubmit with:", dat);

      let pp = {  dat }; 

      let apicall = await axios({
        method: "post",
        url: Base_url + "/common/notificationdelete",
        data: pp ,
      })
       .then((dat) => { 

          console.log(dat.data, "Jsson");
          if (dat.data.status === true) {
            
            alert("Success");

            newstart()
            
          } else {  
            alert(" Failed");
          }
        })
        .catch((ee) => {
          console.log(ee) 
          alert(" Failed sdfvd");
        });
  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10">
          <div className="row">

            <div className="col-8">
              <div style={{ marginBottom : 10 , marginTop : 10  }}>
                <p>Header</p>
                <input
                  type="text"
                  value={pikk}
                  style={{ width : '90%' }}
                  onChange={(e) => {
                    setPikk(e.target.value);
                  }}
                />
              </div>
           
              <div>
                <p>Body</p>
                <textarea
                  type="text"
                  value={pikks}
                  style={{ width : '90%' }}
                  onChange={(e) => {
                    setPikks(e.target.value);
                  }}
                />
              </div>
 
    
              {/* {
                show === true && isFourToFivePM === true ?
                <div>
                  <button onClick={()=>{ User() }}  >Submit </button>
                </div>:""
              } */}


              <div>
                  {
                    show === false ? 
                <button onClick={()=>{ User() }}  >Submit </button>

                : ""
                }

                <button style={{ marginLeft : 30 }} onClick={()=>{ Save() }}  >Save</button>
                
              </div>
                
            </div>

            <div className="col-4">
              <button onClick={()=>{
                navigate('/notificationhistory')
              }}>History</button> 
            </div>

          </div>
          {
            data?.map((dat, index) => {
              return (
                <div className="d-flex justify-content-left" style={{ marginTop : 20 }}>
                  <input
                      type="text"
                      value={dat?.content}
                      style={{ width : '40%' }}
                      disabled
                    />
                    <textarea
                      type="text"
                      value={dat?.deceription}
                      style={{ width : '40%' , marginLeft : 20 , marginRight :  10 }} 
                      disabled
                    />

                    <button onClick={()=>{ Usersubmit( dat?.content , dat?.deceription ) }}  >Submit </button>

                    <button onClick={()=>{ UserDelete( dat ) }}  >Delete </button>
                </div>
              )
            })
          }

          

 
        </div>
      </div>
    </div>
  );
};

export default Notification;
